import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useMutation } from "@apollo/client";

import "./style.scss";
import { UPDATE_FAVORITE } from "../../../schemas/favorite";

export const Arrows = ({getAllFavorites, item, md ,favoriteData,labels}) => {
let length = favoriteData?.getFavorites?.body?.length;
let favoritesNidFirst = favoriteData?.getFavorites?.body[0]?.nid;
let favoritesNidLast = favoriteData?.getFavorites?.body[length-1]?.nid;

const [updateFavorite,{ data: dataInfo, error: errorInfo }] = useMutation(UPDATE_FAVORITE);

  const handleClick = (order, e) => {
    e.preventDefault();
    updateFavorite({
      variables: {
        programInfo: {
          nid: Number(item.nid),
          langcode: item.langcode,
          mark: order,
          notes: ""
        }
      },
    });
  };
  useEffect(() => {
    if (dataInfo) {
      getAllFavorites();
    }
  }, [dataInfo]);
  return (
    <Col xs={6} md={md} className="arrows p-0">
      <Row>
        <div
          className={item.nid==favoritesNidFirst?"disabeld change-weight-plus":"change-weight-plus"}
          tabIndex="0"
          role="button"
          onClick={(e) => handleClick("-", e)}
          aria-label = {labels.arrowUp}
        >
          {" "}
        </div>
        <div
          className={item.nid==favoritesNidLast?"disabeld change-weight-minus":"change-weight-minus"}
          tabIndex="0"
          role="button"
          onClick={(e) => handleClick("+", e)}
          aria-label = {labels.arrowDown}
        >
          {" "}
        </div>
      </Row>
    </Col>
  );
};
